/* eslint-disable no-param-reassign */
/* eslint-disable react/sort-comp */
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import firebase from 'firebase/app'
import { Segment, Grid, Header, Divider, Button } from 'semantic-ui-react'

import utils from '../../utils'

import Loading from '../../components/common/loading'

import Search from './components/Search'
import Setting from './components/Setting'
import OrderList from './components/OrderList'
import DriversBar from './components/DriversBar'
import OrderTabBar from './components/OrderTabBar'
import TrafficConfig from './components/TrafficConfig'

import ModalRefund from '../../components/orders/ModalRefund'
import ModalEditNote from '../../components/orders/ModalEditNote'
import ModalAssignDriver from '../../components/orders/ModalAssignDriver'
import ModalCancelReasons from '../../components/orders/ModalCancelReasons'
import ModalDriversPackage from '../../components/orders/ModalDriversPackage'
import ModalEditOrderItems from '../../components/orders/ModalEditOrderItems'

import UserActions from '../../reducers/userReducer'
import OrderActions from '../../reducers/orderReducer'
import DriverActions from '../../reducers/driverReducer'
import MapViewActions from '../../reducers/mapViewReducer'

class Order extends PureComponent {
  state = {
    currentPage: 1,
    orderTab: {
      value: 'attention',
      text: 'Attention',
    },

    searchedOrders: null,

    modalEditItemsVisible: false,
    modalEditItemsData: null,
    modalEditItemsOrder: null,

    modalPackageVisible: false,
    modalPackageOrder: null,

    modalCancelVisible: false,
    modalCancelData: null,

    modalEditNoteVisible: false,
    modalEditNoteData: null,

    modalReserveDriverVisible: false,
    modalReserveDriverData: null,

    modalAssignDriverVisible: false,
    modalAssignDriverData: null,

    modalSwitchDriverVisible: false,
    modalSwitchDriverData: null,

    modalRefundVisible: false,
    modalRefundData: null,
    lastEditedOrder: null,

    driversGroupByPackage: {
      all: [],
      medium: [],
      small: [],
      large: [],
    },
  }

  componentDidMount() {
    const {
      getAllUsers,
      fetchTimeSlot,
      operatorLoaded,
      syncTodayOrders,
      todayOrdersLoaded,
      readyToPickUpLoaded,
      isReadyToPickupEnabled,
    } = this.props

    if (!todayOrdersLoaded) syncTodayOrders()
    if (!operatorLoaded) getAllUsers()
    if (isReadyToPickupEnabled && !readyToPickUpLoaded) fetchTimeSlot()
  }

  componentWillReceiveProps(nextProps) {
    const { drivers } = this.props

    if (nextProps.drivers && nextProps.drivers !== drivers) {
      this.setDriversGroupByPackage(nextProps.drivers)
    }
  }

  componentWillUnmount() {
    const { removeUsersListener } = this.props

    removeUsersListener()
  }

  setStateAsync = state => new Promise(resolve => this.setState(state, resolve))

  onChangeTabBar = tab => this.setState({ currentPage: 1, orderTab: tab })

  onChangePage = (e, { activePage }) => this.setState({ currentPage: activePage })

  showModalPackage = order => this.setState({ modalPackageOrder: order, modalPackageVisible: true })

  showCancelReasons = (order, forceCancel) => {
    this.setState({ modalCancelData: { ...order, forceCancel }, modalCancelVisible: true })
  }

  showEditNote = order => this.setState({ modalEditNoteVisible: true, modalEditNoteData: order })

  showReserve = order => {
    this.setState({
      modalReserveDriverVisible: true,
      modalReserveDriverData: order,
    })
  }

  showManualAssign = order => {
    this.setState({
      modalAssignDriverVisible: true,
      modalAssignDriverData: order,
    })
  }

  showSwitchDriver = orders => {
    this.setState({ modalSwitchDriverVisible: true, modalSwitchDriverData: orders })
  }

  onClearSearchClick = () => this.setState({ searchedOrders: null })

  onSearchSuccess = filteredOrders => this.setState({ searchedOrders: filteredOrders })

  onModalCancelReasonCancel = () => this.setState({ modalCancelVisible: false, modalCancelData: null })

  onModalDriverPackageCancel = () => this.setState({ modalPackageVisible: false, modalPackageOrder: null })

  onModalEditNoteCancel = () => this.setState({ modalEditNoteVisible: false, modalEditNoteData: null })

  onModalReverseAssignCancel = () => this.setState({ modalReserveDriverVisible: false, modalReserveDriverData: null })

  onModalManualAssignCancel = () => this.setState({ modalAssignDriverVisible: false, modalAssignDriverData: null })

  onModalSwitchAssignCancel = () => this.setState({ modalSwitchDriverVisible: false, modalSwitchDriverData: null })

  onModalEditOrderItemsCancel = () => {
    this.setState({
      modalEditItemsData: null,
      modalEditItemsOrder: null,
      modalEditItemsVisible: false,
    })
  }

  showOrderMap = order => {
    const { setMapData } = this.props
    const { requestCoords } = order
    const deliveryLocation = _.get(order, 'etaInfo.info.legs.0.end_location', {})

    const data = {
      requestCoords,
      deliveryLocation,
    }

    setMapData('order', data)
  }

  showMerchantMapWithDrivers = order => {
    const { setMapData } = this.props

    const deliveryLocation = _.get(order, 'etaInfo.info.legs.0.end_location', {})
    const merchantLocation = _.get(order, 'etaInfo.info.legs.0.start_location', {})

    const { name: merchantName } = order.restaurant
    const data = {
      merchantName,
      deliveryLocation,
      merchantLocation
    }

    setMapData('merchant', data)
  }

  showLiveTracking = order => {
    const { setMapData } = this.props

    const deliveryLocation = _.get(order, 'etaInfo.info.legs.0.end_location', {})
    const merchantLocation = _.get(order, 'etaInfo.info.legs.0.start_location', {})

    const data = {
      merchantLocation,
      deliveryLocation,
      driverUid: order.deliverer,
      merchantName: order.restaurant.name,
    }

    setMapData('live_tracking', data)
  }

  showRefund = order => {
    this.setState({
      modalRefundData: order,
      modalRefundVisible: true
    })
  }

  saveRefundTo = async (order, refundTo, refundNote) => {
    try {
      const updates = {}
      const isRefunded = refundTo && refundTo === 'gift_card'

      updates[`orders/${order.key}/refund_to`] = refundTo
      updates[`orders/${order.key}/refund_note`] = refundNote
      updates[`orders/${order.key}/refunded`] = isRefunded

      const err = await firebase
        .database()
        .ref()
        .update(updates)

      if (err) throw err

      this.setState({
        modalRefundData: null,
        modalRefundVisible: false,
        lastEditedOrder: null,
      })
    } catch (error) {
      alert(error.message || error)
    }
  }

  showEditItems = order => {
    const editItemsData = order.items

    this.setState({
      modalEditItemsVisible: true,
      modalEditItemsData: editItemsData,
      modalEditItemsOrder: order,
      lastEditedOrder: order,
    })
  }

  setDriversGroupByPackage = drivers => {
    const driversGroupByPackage = _.reduce(
      drivers,
      (result, driver) => {
        if (driver.online && driver.location && driver.status === 'available') {
          result[driver.package_size] = result[driver.package_size] || []
          result[driver.package_size].push(driver)

          result.all = result.all || []
          result.all.push(driver)

          return result
        }

        return result
      },
      {}
    )

    this.setState({ driversGroupByPackage })
  }

  render() {
    const {
      orderTab,
      currentPage,
      driversGroupByPackage,
      modalPackageVisible,
      modalPackageOrder,
      modalCancelVisible,
      modalCancelData,
      modalEditNoteData,
      modalEditNoteVisible,
      modalReserveDriverVisible,
      modalReserveDriverData,
      modalAssignDriverVisible,
      modalAssignDriverData,
      modalSwitchDriverVisible,
      modalSwitchDriverData,
      modalEditItemsData,
      modalEditItemsOrder,
      modalEditItemsVisible,
      searchedOrders,
      modalRefundVisible,
      modalRefundData,
      lastEditedOrder,
    } = this.state

    const {
      auth,
      drivers,
      regions,
      todayOrders,
      operatorLoading,
      todayOrdersLoading,
      readyToPickUpLoaded,
      isReadyToPickupEnabled,
      delivereeInProgressOrders,
      delivererInProgressOrders,
    } = this.props

    const orders = todayOrders[orderTab.value]
    const allOrders = (todayOrders.all || []).concat(todayOrders.other || [])

    const loading = todayOrdersLoading || operatorLoading || !(isReadyToPickupEnabled && readyToPickUpLoaded || true)

    return (
      <React.Fragment>
        <Loading active={loading} />

        <Grid style={{ position: 'sticky', zIndex: 3, top: -14 }}>
          <Grid.Column width="16">
            <Segment color="black">
              <div style={{ textAlign: 'center' }}>
                <DriversBar orders={todayOrders.all || []} />
                {
                  searchedOrders
                    ? <Button color="red" floated='right' onClick={this.onClearSearchClick}>Clear Search</Button>
                    : <Search
                        orders={allOrders}
                        drivers={drivers}
                        onSearchSuccess={this.onSearchSuccess}
                      />
                }
                <Setting />
                <Link to="/orders/guide" style={{ float: 'right' }}>
                  <Button floated='right'>Guide</Button>
                </Link>
              </div>
              {
                !searchedOrders &&
                <React.Fragment>
                  <Divider />
                  <OrderTabBar
                    activeTab={orderTab.value}
                    todayOrders={todayOrders}
                    onChange={this.onChangeTabBar}
                    drivers={drivers}
                  />
                </React.Fragment>
              }
            </Segment>
          </Grid.Column>
        </Grid>

        <Grid style={{ zIndex: 2 }}>
          <Grid.Column width="16">
            <Segment color="black">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Header size="large">
                  {searchedOrders ? `Results (${searchedOrders.length})` : orderTab.text}
                </Header>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <TrafficConfig />
                </div>
              </div>

              <OrderList
                regions={regions}
                currentOperator={auth}
                currentPage={currentPage}
                showReserve={this.showReserve}
                onChangePage={this.onChangePage}
                showEditNote={this.showEditNote}
                showOrderMap={this.showOrderMap}
                saveRefundTo={this.saveRefundTo}
                orders={searchedOrders || orders}
                lastEditedOrder={lastEditedOrder}
                showEditItems={this.showEditItems}
                onOpenRefundModal={this.showRefund}
                showModalPackage={this.showModalPackage}
                showLiveTracking={this.showLiveTracking}
                showSwitchDriver={this.showSwitchDriver}
                showManualAssign={this.showManualAssign}
                showCancelReasons={this.showCancelReasons}
                driversGroupByPackage={driversGroupByPackage}
                delivereeInProgressOrders={delivereeInProgressOrders}
                delivererInProgressOrders={delivererInProgressOrders}
                showMerchantMapWithDrivers={this.showMerchantMapWithDrivers}
              />
            </Segment>
          </Grid.Column>
        </Grid>

        <ModalDriversPackage
          visible={modalPackageVisible}
          order={modalPackageOrder}
          onCancel={this.onModalDriverPackageCancel}
        />

        <ModalCancelReasons
          order={modalCancelData}
          visible={modalCancelVisible}
          saveRefundTo={this.saveRefundTo}
          onCancel={this.onModalCancelReasonCancel}
        />

        <ModalEditNote
          order={modalEditNoteData}
          visible={modalEditNoteVisible}
          onCancel={this.onModalEditNoteCancel}
        />

        <ModalAssignDriver
          action="reserve"
          order={modalReserveDriverData}
          visible={modalReserveDriverVisible}
          onCancel={this.onModalReverseAssignCancel}
        />

        <ModalAssignDriver
          action="manual"
          order={modalAssignDriverData}
          visible={modalAssignDriverVisible}
          onCancel={this.onModalManualAssignCancel}
        />

        <ModalAssignDriver
          action="switch"
          visible={modalSwitchDriverVisible}
          onCancel={this.onModalSwitchAssignCancel}
          order={modalSwitchDriverData && modalSwitchDriverData.main}
          queueOrders={modalSwitchDriverData && modalSwitchDriverData.queue}
        />

        <ModalEditOrderItems
          items={modalEditItemsData}
          order={modalEditItemsOrder}
          orders={todayOrders.all || []}
          visible={modalEditItemsVisible}
          onCancel={this.onModalEditOrderItemsCancel}
        />

        {
          modalRefundVisible &&
          <ModalRefund
            order={modalRefundData}
            visible={modalRefundVisible}
            onSave={this.saveRefundTo}
          />
        }
      </React.Fragment>
    )
  }
}

const mapState = ({ orders, drivers, users, auth, regions }) => ({
  auth: auth.data,
  drivers: drivers.drivers,
  operatorLoaded: users.loaded,
  operatorLoading: users.loading,
  todayOrders: orders.todayOrders,
  todayOrdersLoaded: orders.todayOrdersLoaded,
  isReadyToPickupEnabled: drivers.readyToPickUp,
  todayOrdersLoading: orders.todayOrdersLoading,
  readyToPickUpLoaded: drivers.readyToPickUpLoaded,
  delivereeInProgressOrders: orders.delivereeInProgressOrders,
  delivererInProgressOrders: orders.delivererInProgressOrders,
  regions: utils.helpers.convertArrayToObject(regions.data, 'id'),
})

const mapDispatch = {
  getAllUsers: UserActions.getAllUsers,
  setMapData: MapViewActions.setMapData,
  fetchTimeSlot: DriverActions.fetchTimeSlot,
  syncTodayOrders: OrderActions.syncTodayOrders,
  removeUsersListener: UserActions.removeUsersListener,
}

export default connect(
  mapState,
  mapDispatch
)(Order)



// WEBPACK FOOTER //
// ./src/containers/orders/index.js